<script>
export default {
  name: 'ChallengeCard',

  props: {
    challenge: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      deleted: false
    }
  },

  methods: {
    deleteChallenge() {
      if (!confirm('SURE ?')) {
        return
      }

      this.axios.delete('/challenges/' + this.challenge.id)
        .then(() => {
          this.$alert({
            type: 'success',
            trans: 'messages.challenge_deleted'
          })
          this.deleted = true
        })
    }
  }
}
</script>

<template>
  <div class="card" v-if="!deleted">
    <div class="card-image"
       v-if="challenge.image">
      <figure class="image is-4by3">
        <img :src="challenge.image" :alt="challenge.name">
      </figure>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title is-4">
            {{ challenge.name }}
            <span class="tag is-primary">{{ challenge.category }}</span>
            <span class="tag is-info">Level {{ challenge.level }}</span>
            <span class="tag is-dark">Participants ({{ challenge.players_count }})</span>
          </p>
        </div>
      </div>

      <div class="content">
        <div
          class="description"
          v-html="$linkifyStr(challenge.description)"></div>
        <div>
          du <time class="has-text-weight-bold">{{ challenge.started_at | moment('DD/MM/YY') }}</time>
          au <time class="has-text-weight-bold">{{ challenge.ended_at | moment('DD/MM/YY') }}</time>
        </div>
      </div>
    </div>

    <footer class="card-footer">
      <router-link
        class="card-footer-item"
        :to="{name: 'challenge_edit', params: {id: challenge.id}}">
        Modifier
      </router-link>
      <a class="card-footer-item"
        @click="deleteChallenge">
        Supprimer
      </a>
    </footer>
  </div>
</template>

<style scoped>
.media-content {
  overflow: initial;
}

.description {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/ChallengeCard.vue